import { ISkillCategoryDetailDTO } from '@sharedInterfaces/ISkillCategory';

import { SkillCategory } from './SkillCategory';

export function createSkillCategory(data: ISkillCategoryDetailDTO): SkillCategory
{
    return new SkillCategory(data);
}